const Purchase = () => import(/* webpackChunkName: "purchase" */ '@/views/private/purchase/Index.vue')

const routes = [
  {
    path: "/purchase",
    name: "purchase",
    component: Purchase,
    meta: {
      title: "Data Pembelian"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})